import { clone, path, pathOr } from 'ramda';
import {
	CLEAR_AUTH_ORGANIZATIONS,
	CLEAR_AUTH_ORGANIZATION_UPDATE_ERRORS,
	CLEAR_AUTH_ORGANIZATION_CREATE_ERRORS,
	GET_AUTH_ORGANIZATION,
	GET_AUTH_ORGANIZATIONS,
	FETCH_AUTH_ORGANIZATION_FAILED,
	FETCH_AUTH_ORGANIZATIONS_FAILED,
	FETCH_AUTH_ORGANIZATION_SUCCEEDED,
	FETCH_AUTH_ORGANIZATIONS_SUCCEEDED,
	UPDATE_AUTH_ORGANIZATION,
	UPDATE_AUTH_ORGANIZATION_FAILED,
	UPDATE_AUTH_ORGANIZATION_SUCCEEDED,
	CREATE_AUTH_ORGANIZATION,
	CREATE_AUTH_ORGANIZATION_FAILED,
	CREATE_AUTH_ORGANIZATION_SUCCEEDED,
} from './authOrganization.action';
import { authOrganizationsInitialState } from './authOrganization.initialState';

const createPendingState = (state, pendingType) => ({
	...state,
	[pendingType]: true,
});

const createErrorState = (state, pendingType, errorType, error) => ({
	...state,
	[pendingType]: false,
	[errorType]: error,
});

const clearErrorState = (state, errorType) => ({
	...state,
	[errorType]: null,
});

export const authOrganizationReducer = (state = authOrganizationsInitialState, action) => {
	switch (action.type) {
		case CLEAR_AUTH_ORGANIZATIONS: {
			return {
				...state,
				...authOrganizationsInitialState,
			};
		}

		case CLEAR_AUTH_ORGANIZATION_UPDATE_ERRORS: {
			return clearErrorState(state, 'updateError');
		}

		case CLEAR_AUTH_ORGANIZATION_CREATE_ERRORS: {
			return clearErrorState(state, 'createError');
		}

		case GET_AUTH_ORGANIZATION:
		case GET_AUTH_ORGANIZATIONS: {
			return createPendingState(state, 'pendingFetch');
		}

		case FETCH_AUTH_ORGANIZATION_FAILED:
		case FETCH_AUTH_ORGANIZATIONS_FAILED: {
			return createErrorState(state, 'pendingFetch', 'fetchError', action.payload);
		}

		case FETCH_AUTH_ORGANIZATION_SUCCEEDED: {
			const fetchedAuthOrgId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingFetch: false,
			};
			if (fetchedAuthOrgId) {
				newState.entities = {
					...state.entities,
					[fetchedAuthOrgId]: action.payload,
				};
			}

			return newState;
		}

		case FETCH_AUTH_ORGANIZATIONS_SUCCEEDED: {
			const previousStateEntities = clone(state.entities);
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;

				return accumulator;
			}, previousStateEntities);

			return {
				...state,
				entities,
				pendingFetch: false,
			};
		}

		case UPDATE_AUTH_ORGANIZATION: {
			return createPendingState(state, 'pendingUpdate');
		}

		case UPDATE_AUTH_ORGANIZATION_FAILED: {
			return createErrorState(state, 'pendingUpdate', 'updateError', action.payload);
		}

		case UPDATE_AUTH_ORGANIZATION_SUCCEEDED: {
			const updatedAuthOrgId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingUpdate: false,
			};

			if (updatedAuthOrgId) {
				newState.entities = {
					...state.entities,
					[updatedAuthOrgId]: action.payload,
				};
			}

			return newState;
		}

		case CREATE_AUTH_ORGANIZATION: {
			return createPendingState(state, 'pendingCreate');
		}

		case CREATE_AUTH_ORGANIZATION_FAILED: {
			return createErrorState(state, 'pendingCreate', 'createError', action.payload);
		}

		case CREATE_AUTH_ORGANIZATION_SUCCEEDED: {
			const createdAuthOrgId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingCreate: false,
			};

			if (createdAuthOrgId) {
				newState.entities = {
					...state.entities,
					[createdAuthOrgId]: action.payload,
				};
			}

			return newState;
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/authOrganizations/authOrganization.reducer.js